import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'cellFormatter' })
export class CellFormatter implements PipeTransform {
  transform(value: number | string, cellType: 'STRING' | 'PERCENT') {
    return cellType === 'PERCENT' ? `${((value as number) * 100).toFixed(1)}%` : value;
  }
}
